import {
  requestPasswordResetTokenUrl,
  RedeemTokenTypeToURLMap,
} from './util/constants';
import { RedeemTokenTypes } from './views/RedeemToken';

export const timeout = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const requestPasswordReset = (email: string) => {
  return fetch(requestPasswordResetTokenUrl, {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    body: JSON.stringify({ email }),
  });
};

export const redeemToken = (
  tokenType: RedeemTokenTypes,
  token: string,
  email: string,
  pw?: string,
) => {
  const redeemUrl = RedeemTokenTypeToURLMap[tokenType];
  return fetch(redeemUrl, {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    body: JSON.stringify({
      token,
      email,
      ...(pw && { pw }),
    }),
  });
};
